import { useState, useCallback } from "react"

import { useOnResize } from "./use-on-resize"

export const useIsMobile = () => {
  const getIsMobile = useCallback(
    () =>
      (window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth) < 600,
    [],
  )

  const [isMobile, setIsMobile] = useState(getIsMobile())

  useOnResize(() => setIsMobile(getIsMobile()), [])

  return isMobile
}
